import { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { buildSourceURL } from '../../utils/functions';
import { getProducts, getProductCategories, deleteProduct } from '../../actions/product';
import ProductModal from '../../components/ProductModal/ProductModal';
import styles from './Productions.module.css';

const Productions = (props) => {
  const { 
    getProducts,
    getProductCategories,
    productsData,
    categoriesData,
    deleteProduct,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  useEffect(() => {
    getProducts();
    getProductCategories();
  }, []);

  const groupedCategories = useMemo(() => {
    return categoriesData.reduce((groupedCategories, categoryData) => {
      groupedCategories[categoryData.id] = categoryData.name;
      return groupedCategories;
    }, {});
  }, [categoriesData]);

  console.log('===groupedCategories', groupedCategories);

  const openModalHandler = () => {
    setInitialValue(null);
    setShowModal(true);
  };

  const editHandler = (productData) => {
    setInitialValue(productData);
    setShowModal(true);
  };

  const deleteHandler = (id) => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteProduct(id);
    }
  };
  
  const renderImage = (imageData) => {
    if (imageData.image) {
      const imageURL = imageData.image.startsWith('http')
        ? imageData.image
        : buildSourceURL(imageData.image);

      return (
        <img className={styles.dishImage} src={imageURL} />
      );
    }
  };

  return (
    <div className="wrapper">
      <ProductModal 
        key={initialValue?.id + productsData.length}
        isOpen={showModal} 
        onClose={() => setShowModal(false)}
        initialValue={initialValue}
        categoriesData={categoriesData}
      />
      <div className={styles.tools}>
      <h1>
        Products
      </h1>
      <div className={styles.buttons}>
        <div className={styles.addDish} onClick={openModalHandler}>
          Add product
        </div>
      </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
        <tr>
          <th>Id</th>
          <th>Image</th>
          <th>Name</th>
          <th>Package weight</th>
          <th>Category</th>
          <th>Link</th>
          <th>Controls</th>
        </tr>
        </thead>
        <tbody>
        {productsData?.map((productItem) => (
          <tr key={productItem.id}>
            <td>
              {productItem.id}
            </td>
            <td>{renderImage(productItem)}</td>
            <td>
              {productItem.name}
            </td>
            <td>{productItem.package_weight && `${productItem.package_weight} grams`}</td>
            <td>{groupedCategories[productItem.category_id]}</td>
            <td className={styles.withLink}>{productItem.link ? '🌐' : ''}</td>
            <td className="controls">
              <button className="button green-button" onClick={() => editHandler(productItem)}>
                Edit
              </button>
              <button className="button red-button" onClick={() => deleteHandler(productItem.id)}>
                Delete
              </button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.productsData,
  categoriesData: store.product.categoriesData,
});

const mapDispatchToProps = {
  getProducts,
  getProductCategories,
  deleteProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(Productions);